// extracted by mini-css-extract-plugin
module.exports = {"container":"ActFastMessage_container__93wCg"};